// extracted by mini-css-extract-plugin
export var errorIcon = "_m7-1";
export var nameLogo = "_m7-0";